import type { ComponentDefinition } from '../components/ui-element.type';
import type { UIElement } from '../components';
import type { GenericDecorator } from './decorator.type';

export function Component<T extends typeof UIElement>(
    config: ComponentDefinition
): GenericDecorator<T, ClassDecoratorContext>;

/**
 * Defines the component with tag and styles.
 * @param {ComponentDefinition} config - Component configuration with tag, styles, and optional CMS metadata
 */
export function Component<T extends typeof UIElement>(
    config: ComponentDefinition
): GenericDecorator<T, ClassDecoratorContext> {
    if (!config.tag) {
        throw new Error('tag property should exists in @Component decorator');
    }

    return (target: T, context: ClassDecoratorContext) => {
        if (context.kind === 'class') {
            // @ts-expect-error Call protected defineElement method from UIElement base class for legacy compatibility purposes.
            return target.defineElement(config.tag, config.styles) as T;
        } else {
            throw new Error('@Component decorator is applied only to a class.');
        }
    };
}
